import { ProcedureUnitTypeRule } from '../../models/unit-type-rules-config';
import { UnitTypes } from '@modules/teeth-diagram/models/unit-type.enum';
import { allTeeth } from '../teeth-sets';
import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import { ProcedureTypeEnum } from '@core/procedure-helpers/models/procedure-type.enum';

export const rulesForImplantPlanning: ProcedureUnitTypeRule = {
	ProcedureMaps: [
		{
			ProcedureId: ProcedureEnum.ImplantPlanning,
			TypeId: ProcedureTypeEnum.None
		},
		{
			ProcedureId: ProcedureEnum.ImplantPlanning,
			TypeId: ProcedureTypeEnum.SurgicalGuideTissueSupported
		},
		{
			ProcedureId: ProcedureEnum.ImplantPlanning,
			TypeId: ProcedureTypeEnum.SurgicalGuideBoneSupported
		},
		{
			ProcedureId: ProcedureEnum.ImplantPlanning,
			TypeId: ProcedureTypeEnum.SurgicalPlanningOnlyNoGuide
		}
	],
	TeethRules: [
		{
			Ids: allTeeth,
			UnitAndMaterialRules: {
				UnitTypeRules: [
					{
						Id: UnitTypes.ImplantPosition
					},
					{
						Id: UnitTypes.Regular
					}
				]
			}
		}
	]
};
